import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { AuthService } from '@app/services/auth.service';
import { SnackbarService } from '@shared/services/snackbar.service';

@Component({
  selector: 'lgv-login',
  templateUrl: './login.component.html',
  styles: [
    `
      :host {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
      }
      .form {
        min-height: 200px;
      }
    `,
  ],
  standalone: false,
})
export class LoginComponent implements OnInit {
  private snackbarService = inject(SnackbarService);
  private authService = inject(AuthService);

  isLoading = false;
  hidePassword = true;
  isOPTMode = false;

  formGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    password: new UntypedFormControl('', [Validators.required]),
    optcode: new UntypedFormControl('', []),
  });

  ngOnInit(): void {
    this.formGroup.valueChanges.subscribe((field) => {
      if (field.password.length < 8) {
        this.getField('password').setErrors({ notValid: true });
      } else {
        this.getField('password').setErrors(null);
      }

      if (this.isOPTMode && field.optcode.length < 6) {
        this.getField('optcode').setErrors({ notValid: true });
      }
    });
  }

  async submit(): Promise<void> {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
    } else {
      try {
        this.isLoading = true;
        const username = this.getField('email').value;
        const password = this.getField('password').value;
        let otpToken: string | undefined;
        if (this.isOPTMode) {
          otpToken = this.getField('optcode').value;
        }
        await this.authService.login({ password, username, otpToken });
      } catch (error) {
        if (
          error.includes &&
          error.includes('Error Code: 400') &&
          error.includes('Message: OTP token is required for this user')
        ) {
          this.isOPTMode = true;
        } else if (error.includes && error.includes('Error Code: 429')) {
          this.snackbarService.showError('auth_login_info_toomanyattempts');
        } else {
          this.getField('password').setValue('');
          this.getField('optcode').setValue('');
          this.snackbarService.showError('auth_login_info_loginfailed');
          throw error;
        }
      } finally {
        this.isLoading = false;
      }
    }
  }

  getField(name: string): AbstractControl {
    return this.formGroup.get(name);
  }
}
